import React from "react";
import { useTranslation } from "react-i18next";
import { Props } from "./types";

function useWizardForm(props: Props) {
  const { t } = useTranslation();
  const [currentStep, setCurrentStep] = React.useState(0);
  const { component, canMoveToNextStep, placeholder, title } =
    props.steps[currentStep >= props.steps.length ? 0 : currentStep];
  const nextPlaceholder = placeholder
    ? placeholder.next || t("wizardForm.next")
    : t("wizardForm.next");
  const previousPlaceholder = placeholder
    ? placeholder.previous || t("wizardForm.previous")
    : t("wizardForm.previous");
  const submitPlaceholder = props.submitPlaceholder
    ? props.submitPlaceholder
    : t("wizardForm.submit");
  const isFirstStep = () => currentStep === 0;
  const isLastStep = () => currentStep === props.steps.length - 1;
  const incrementStep = () =>
    canMoveToNextStep && setCurrentStep(currentStep + 1);
  const decrementStep = () => setCurrentStep(currentStep - 1);

  return {
    component,
    title,
    nextPlaceholder,
    previousPlaceholder,
    canMoveToNextStep,
    submitPlaceholder,
    currentStep,
    isFirstStep,
    isLastStep,
    incrementStep,
    decrementStep,
  };
}

export { useWizardForm };
